import React, { useEffect, useState } from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { Mail, Lock, UserPlus } from "lucide-react";
import userAPI from "../../api/UserApi";
import { showError, showSuccess } from "../../utils/toastUtils";
import { setAccessToken } from "../../api/axiosInstance";
import useAlphabeticInput from "../../hooks/useAlphabeticInput";
import { handleApiValidationError } from "../../utils/apiErrorHandler";

function ForgotPasswordCanvas() {
  useAlphabeticInput();
  const navigate = useNavigate();

  const INITIAL_FORM_DATA = {
    email: "",
  };

  const [formData, setFormData] = useState(INITIAL_FORM_DATA);
  const [errors, setErrors] = useState({});
  const [general, setGeneral] = useState("");
  const [loading, setLoading] = useState(false);

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const isValidEmail = emailRegex.test(formData.email);

  const validate = () => {
    const newErrors = {};
    if (!formData.email) {
      newErrors.email = "Please Enter Email Address";
    } else if (!isValidEmail) {
      newErrors.email = "Please enter a valid email";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (!validate()) {
      setLoading(false);
      return;
    }

    try {
      const res = await userAPI.forgotPassword(formData);

      if (res.code === 200) {
        setGeneral(res.message);
        setFormData(INITIAL_FORM_DATA);
      }
    } catch (err) {
      handleApiValidationError(err, setErrors);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="custom-loginpage-wrapper">
        <Container fluid className="h-100 p-0">
          <Row className="h-100 g-0">
            {/* Left Side: Editorial Image */}
            <Col lg={6} className="d-none d-lg-block custom-loginpage-imagebox">
              <div className="login-image-overlay"></div>
            </Col>

            {/* Right Side: Login Form */}
            <Col
              lg={6}
              className="d-flex justify-content-center align-items-center p-4 p-md-5"
            >
              <div className="custom-loginpage-formbox">
                <h1 className="custom-loginpage-title mb-1">Forgot Password</h1>
                <p className="text-muted mb-5">
                  Enter your email to Reset Password
                </p>

                <Form method="post" onSubmit={handleSubmit}>
                  <Form.Group className="mb-3" controlId="email">
                    <Form.Label className="custom-form-label">
                      Email Address <span className="text-danger">*</span>
                    </Form.Label>
                    <div className="input-group-custom">
                      <Mail size={18} className="input-icon" />
                      <Form.Control
                        type="email"
                        name="email"
                        placeholder="Email Address"
                        value={formData.email}
                        onChange={handleChange}
                      />
                    </div>
                    {errors && errors.email && (
                      <span className="text-danger">{errors.email}</span>
                    )}
                  </Form.Group>

                  <Button
                    className="custom-loginpage-submitbtn btn w-100 py-3"
                    type="submit"
                  >
                    {loading ? "Sending..." : "SEND RESET LINK"}
                  </Button>

                  {general && (
                    <span className="fw-medium mt-2 text-success">{general}</span>
                  )}
                </Form>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}

export default ForgotPasswordCanvas;
